import { Options } from 'highcharts';
import merge from 'lodash/merge';
import baseChartOptions from '../options';
import theme from 'styles/themes/reports';

const optionsMobile: Options = {
  chart: {
    type: 'pie',
    height: '260px',
    spacing: [35, 35, 35, 35]
  },
  title: {
    verticalAlign: 'middle',
    style: {
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: String(theme.typography.fontWeightBold),
      marginTop: '5px'
    },
    align: 'center',
    y: 18
  },
  tooltip: {
    pointFormat: '<b>{point.percentage:.2f}%</b>'
  },
  plotOptions: {
    pie: {
      innerSize: '65%',
      size: '60%',
      borderWidth: 3,
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: true,
        connectorShape: 'crookedLine',
        connectorPadding: 0,
        distance: 15,
        y: -4,
        style: {
          fontSize: theme.typography.pxToRem(14),
          fontWeight: String(theme.typography.fontWeightRegular),
          color: theme.palette.text.secondary
        },
        useHTML: true
      }
    }
  }
};

export default merge({}, baseChartOptions, optionsMobile);
